import { Checkbox, CheckboxOnChangeData } from "@fluentui/react-components";
import { Flex } from "@/components/atoms/flex";
import { MultiCheckboxProps } from "./types";

export const MultiCheckbox = (props: MultiCheckboxProps) => {
	const { items, onChange, styles, classNames } = props;

	return (
		<Flex column style={styles?.root} className={classNames?.root}>
			{items.map((x) => (
				<Checkbox
					key={x.key}
					disabled={x.disabled}
					label={{ children: x.label, title: x.label }}
					checked={x.checked}
					style={styles?.item}
					className={classNames?.item}
					onChange={(_: any, data: CheckboxOnChangeData) =>
						onChange(x, data.checked)
					}
				/>
			))}
		</Flex>
	);
};
